module.exports = __webpack_public_path__ + "UX22.jpg?f86df3a4a576ba5b569bc4f5e9d54657";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX22.jpg
// module id = 72
// module chunks = 0